function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { NavigationClient } from '@azure/msal-browser';
/**
 * A NavigationClient which can navigate in a single page application
 * using a router, instead of by reloading the entire site.
 *
 * You must pass a `navigate` function to the constructor. Its signature
 * matches the navigate function from reach router.
 */

export class RouterNavigationClient extends NavigationClient {
  constructor(navigate) {
    super();
    this.navigate = navigate;
  }

  navigateInternal(url, options) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var path = url.substr(window.location.origin.length);

      _this.navigate(path, {
        replace: options.noHistory
      });

      return false;
    })();
  }

}